<h2 mat-dialog-title>{{ 'administration.sync-monitoring.keep-dialog.title' | translate }}</h2>

<mat-dialog-content>
	<p class="audit-dialog-note">{{ 'administration.sync-monitoring.keep-dialog.description' | translate }}</p>
	<p class="audit-dialog-target">
		<span class="audit-dialog-label">{{ 'administration.sync-monitoring.tables.columns.name' | translate }}:</span>
		<strong>{{ data.tableName }}</strong>
	</p>
	<p class="audit-dialog-target">
		<span class="audit-dialog-label">{{ 'administration.sync-monitoring.keep-dialog.version' | translate }}:</span>
		{{ data.version }}
	</p>
	<p class="audit-dialog-target">
		<span class="audit-dialog-label">{{ 'administration.sync-monitoring.keep-dialog.marked-by' | translate }}:</span>
		{{ data.runId }}
	</p>
	<p class="audit-dialog-target">
		<span class="audit-dialog-label">{{ 'administration.sync-monitoring.keep-dialog.expires' | translate }}:</span>
		{{ expiresAt }}
	</p>

	<h4>{{ 'administration.sync-monitoring.keep-dialog.count' | translate: { count: data.keys.length } }}</h4>
	<div class="audit-dialog-keys">
		@for (key of data.keys; track key) {
			<span>{{ key }}</span>
		}
	</div>
	<p class="audit-dialog-note">
		{{ (data.otherCount > 0 ? 'administration.sync-monitoring.keep-dialog.others' : 'administration.sync-monitoring.keep-dialog.no-others') | translate: { count: data.otherCount, expires: expiresAt } }}
	</p>
	<p class="audit-dialog-note">{{ 'administration.sync-monitoring.keep-dialog.marked-again' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" [disabled]="isLoading" (click)="onCancel()">
		{{ 'general.cancel' | translate }}
	</button>
	<button mat-flat-button color="primary" type="button" [disabled]="isLoading" (click)="onConfirm()">
		@if (isLoading) {
			<mat-progress-spinner diameter="18" mode="indeterminate" class="audit-dialog-spinner"></mat-progress-spinner>
		}
		{{ 'administration.sync-monitoring.keep-dialog.confirm' | translate: { count: data.keys.length } }}
	</button>
</mat-dialog-actions>
